import { DailyParticipant } from '@daily-co/daily-js';
import { MunchedImage } from 'sb-lib/types';

export type VideoBackground = {
  id: string;
  image: MunchedImage;
  owner: 'COMMON' | 'USER';
};

export interface VideoRecording {
  id: number | string;
  name: string;
  videoUrl: string;
  dateCreated: string;
}

export interface VideoRoom {
  id: string;
  providerName: 'daily';
  dailyVideoRoom?: {
    id: string;
    name: string;
    url: string;
  };
}

export enum VideoParticipantType {
  LIVELISTEN = 'livelisten',
  SALESFLOOR = 'salesfloor',
}
export interface VideoParticipantUserData {
  participantType: VideoParticipantType;
}
export interface VideoParticipantWithUserData extends DailyParticipant {
  userData?: VideoParticipantUserData;
}

export interface VideoParticipantsWithUserDataObject {
  local: VideoParticipantWithUserData;
  [id: string]: VideoParticipantWithUserData;
}
